import * as React from "react"
import type { SVGProps } from "react"
const SvgCode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14.24 3.03a1 1 0 0 1 .73 1.21l-4 16a1 1 0 1 1-1.94-.48l4-16a1 1 0 0 1 1.21-.73m3.05 4.26a1 1 0 0 1 1.42 0l4 4a1 1 0 0 1 0 1.42l-4 4a1 1 0 1 1-1.42-1.42L20.6 12l-3.3-3.3a1 1 0 0 1 0-1.4m-12 0a1 1 0 0 1 1.42 1.42L3.4 12l3.3 3.3a1 1 0 1 1-1.42 1.4l-4-4a1 1 0 0 1 0-1.4z" />
  </svg>
)
export default SvgCode
